export default __webpack_public_path__ + "static/onboarding2-8d871f8a62d78bcb0e6bc165d9ca43bb.webp";